module.exports = __webpack_public_path__ + "img/video_backgroup.6f714e1b.jpg";